export function stageState(done, pending) {
    if (done) return 'done';
    if (pending) return 'pending';
    return 'idle';
}

export function productionStages(sku) {
    const shootDone = !!(sku?.isPendingAtRawQC || sku?.isRawQCComplete);
    const rawDone = !!sku?.isRawQCComplete;
    const rawPending = !!sku?.isPendingAtRawQC && !rawDone;
    const productionOn = !!(sku?.postProductionStatus?.InProduction || sku?.postProductionStatus?.PrincipalProduction);
    const clientQc = !!sku?.postProductionStatus?.PrincipalClientQC;
    const delivery = !!sku?.postProductionStatus?.PrincipalDelivery;
    return [
        { key: 'dd', label: 'DD Approved', sub: sku?.isDDApproved ? 'Approved' : '', state: sku?.isDDApproved ? 'done' : 'idle' },
        { key: 'shoot', label: 'Shoot complete', sub: shootDone ? 'Complete' : '', state: shootDone ? 'done' : 'idle' },
        {
            key: 'raw',
            label: 'Raw QC',
            sub: rawDone ? 'Complete' : rawPending ? 'Pending' : '',
            state: stageState(rawDone, rawPending),
        },
        {
            key: 'production',
            label: 'Production',
            sub: delivery || clientQc ? 'Complete' : productionOn ? 'In production' : '',
            state: stageState(delivery || clientQc, productionOn),
        },
        {
            key: 'client',
            label: 'Client QC',
            sub: delivery ? 'Complete' : clientQc ? 'Pending' : '',
            state: stageState(delivery, clientQc),
        },
        { key: 'delivery', label: 'Delivery', sub: delivery ? 'Complete' : '', state: delivery ? 'done' : 'idle' },
    ];
}

export function flagText(value) {
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    return '—';
}
